import CaseFilter from '../statistics';
import CaseVolume from '../caseVolumeLineChart';
import CustomPieChart from '../customPieChart';
import CustomComponentAreaCaseBySubmission from '../customComponentAreaCaseBySubmission';
import GeographicalStatistics from '../geographicalStatistics';
import { FC } from 'react';
import { GeographicalStatisticsObject } from 'src/pages/manufacturer/types';
// import AuthMaunfacturerSubHeader from '../authManufacturerSubHeader';
import { AllProductProps } from '../allProductsStats/types';
import DrillDownPieChart from '../drillDownPieChart';
import CaseListing from '../caseListing';

const ZilrettaRegion: FC<AllProductProps> = ({ statisticsData, queryParams, updateQueryParamsAndCallAPI, getStatisticsData,drug }): JSX.Element => {
    return (
        <div className={`${drug === "iovera" ? 'iovera-content' : drug === "ZILRETTA" ? 'zilretta-content' : ''}`}>
            {statisticsData && (
                <CaseFilter
                    defaultQueryParams={queryParams}
                    updateQueryParams={updateQueryParamsAndCallAPI}
                    drug={drug}
                />
            )}
            {statisticsData && queryParams && (
                <CaseVolume startDate={queryParams.start_date} endDate={queryParams.end_date}
                            StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData}
                            buttonShows={true} showPractice={true} drug={''}/>
            )}
            <div className="row">
                <div className="col-12 col-lg-6">
                    {statisticsData &&
                        <CustomPieChart pieChartObject={statisticsData.data.top_payors} title={'Top 10 Payors'}/>}
                </div>
                <div className="col-12 col-lg-6">
              {statisticsData && statisticsData.data &&
                <CustomPieChart title="Top 10 Payor Types" pieChartObject={statisticsData.data.top_payer_types} />
              }
          </div>
                <div className="col-12 col-lg-12">
                    {statisticsData && statisticsData.data &&
                        <DrillDownPieChart pieChartObject={statisticsData.data.icd_zilreta_data}
                                           title={'Top 10 ICD Codes'}
                        />
                    }
                </div>
            
            {statisticsData && drug && queryParams && (
                <CustomComponentAreaCaseBySubmission startDate={queryParams.start_date} endDate={queryParams.end_date}
                                                     StatisticsObjectType={statisticsData.data} title={'Regions'}
                                                     drug={drug} isFullRow={true} />
            )}

            {statisticsData && statisticsData.data ?
                <CaseListing drug={drug} queryParams={queryParams} caseListing={statisticsData.data.case_listing} />
                : null
            }

            {statisticsData?.data && (
                <GeographicalStatistics
                    GeographicalStatisticsListType={
                        statisticsData?.data
                            .geographical_stats as unknown as GeographicalStatisticsObject[]
                    }
                />
            )}
        </div>
        </div>
    );
}
export default ZilrettaRegion;